import {useDeleteAssetsQuery, useFavAssetsQuery} from "hooks";
import {getFullAssetUrl} from "utils";
import {ASSET_TYPE} from "components/Layout/constants";
import {showPopUp} from "components/PopUp";
import AssetPropertiesPopup from "../AssetPropertiesPopup";
import DefaultThumbnail from "images/objectPanel/ic_default_thumbnail.svg";
import SoundIcon from "images/objectPanel/ic_sound.svg";

function useHandleAssetInfo() {
  const favMutation = useFavAssetsQuery();
  const deleteMutation = useDeleteAssetsQuery();

  const checkFileType = fileValue => {
    let assetType = "";
    const fileType = fileValue.substring(fileValue.lastIndexOf("."), fileValue.length).toLowerCase().replace(".", "");

    switch (fileType) {
      case "gltf":
      case "glb":
        assetType = ASSET_TYPE.MODEL;
        break;
      case "png":
      case "jpg":
      case "jpeg":
        assetType = ASSET_TYPE.IMAGE;
        break;
      case "mov":
      case "mp4":
      case "mpeg":
        assetType = ASSET_TYPE.VIDEO;
        break;
      case "wav":
      case "mp3":
        assetType = ASSET_TYPE.SOUND;
        break;
      default:
        assetType = ASSET_TYPE.NOT_SUPPORTED;
        break;
    }
    return {assetType, fileType};
  };

  const onClickDownload = (name, url, mimeType) => {
    const a = document.createElement("a");
    a.href = getFullAssetUrl(url);
    a.download = `${name || "redbrick_asset"}.${mimeType}`;
    a.click();
  };

  const onClickFavorite = (id, likeStatus) => {
    const params = {
      id: id,
      likeStatus: likeStatus,
    };
    favMutation.mutateAsync(params);
  };

  const onClickEditBtn = asset => {
    showPopUp(<AssetPropertiesPopup asset={asset} />, {
      defaultPadding: false,
      noBackground: true,
    });
  };

  const deleteAsset = assetId => {
    deleteMutation.mutateAsync(assetId);
  };

  const handleAssetThumbnail = data => {
    const isSound = data.topCategory === ASSET_TYPE.SOUND;
    const isModel = data.topCategory === ASSET_TYPE.MODEL && data.midCategory != "LIGHT" && data.midCategory !== "CAMERA";
    if (isSound) return SoundIcon;
    if (isModel) return DefaultThumbnail;
    return data?.thumbnailUrl;
  };

  return {checkFileType, onClickDownload, onClickFavorite, deleteAsset, onClickEditBtn, handleAssetThumbnail};
}

export default useHandleAssetInfo;
